module.exports = __webpack_public_path__ + "img/benchmark.40cfa117.svg";